import React from "react";
import { Link } from "react-router-dom";
import { Smartphone } from "lucide-react";
import Modal from "./Modal";

interface MobileDownloadPromptModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export default function MobileDownloadPromptModal({
  isOpen,
  onClose,
}: MobileDownloadPromptModalProps) {
  return (
    <Modal isOpen={isOpen} onClose={onClose} size="sm" className="max-w-md">
      <div className="p-6 sm:p-7">
        <div className="mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-[#1FA9FF]/10 text-[#1FA9FF]">
          <Smartphone className="h-6 w-6" />
        </div>

        <h3 className="text-center text-xl font-bold text-gray-900">
          You&apos;re on mobile
        </h3>
        <p className="mt-2 text-center text-sm text-gray-600">
          Hey, it looks like you&apos;re on mobile. Download the app to get
          started.
        </p>

        <div className="mt-6 flex flex-col gap-2">
          <Link
            to="/download"
            onClick={onClose}
            className="w-full rounded-full bg-[#1FA9FF] px-4 py-2.5 text-center text-sm font-semibold text-white transition-opacity hover:opacity-90"
          >
            Download App
          </Link>
          <button
            type="button"
            onClick={onClose}
            className="w-full rounded-full border border-gray-300 px-4 py-2.5 text-sm font-semibold text-gray-700 transition-colors hover:bg-gray-50"
          >
            Continue Browsing
          </button>
        </div>
      </div>
    </Modal>
  );
}
